import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.8
  }} className="my-16 p-8 bg-[#1B2A4A]/5 rounded-lg border border-[#1B2A4A]/10" data-id="element-101">
      <div className="flex items-center justify-center gap-3 mb-6" data-id="element-102">
        <ShieldCheckIcon className="w-8 h-8 text-[#D4652A]" data-id="element-103" />
        <h3 className="text-2xl md:text-3xl font-bold text-[#1B2A4A]" data-id="element-104">
          The Handshake Guarantee
        </h3>
      </div>

      <div className="space-y-6 text-lg text-[#1B2A4A] text-center max-w-2xl mx-auto" data-id="element-105">
        <p data-id="element-106">
          Read the entire guide. Use the checklists. Call the SSA with the
          scripts.
        </p>
        <p data-id="element-107">
          If you don&apos;t find at least one actionable path to increase your
          monthly check, email us within 30 days and we&apos;ll refund every
          penny. No questions. No hassle. No hard feelings.
        </p>
        <p className="font-bold italic text-xl pt-4" data-id="element-108">
          You&apos;ve already lost enough money on this. You shouldn&apos;t have
          to risk $6.36 more to find out if there&apos;s a fix.
        </p>
      </div>
    </motion.section>;
}